import { render, staticRenderFns } from "./CaseNoteHeader.vue?vue&type=template&id=6f32019b&v-slot%3Aheader=true"
import script from "./CaseNoteHeader.vue?vue&type=script&lang=js"
export * from "./CaseNoteHeader.vue?vue&type=script&lang=js"
import style0 from "./CaseNoteHeader.vue?vue&type=style&index=0&id=6f32019b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports